/// <reference path="../../../app.d.ts"/>
import { DataCorrectionController } from './DataCorrectionController';
import { FeedbackType } from '../../models/FeedbackFormModel';
import { CorrectionResponseApi } from '../../models/CorrectionResponseApi';
import { AppUtils } from '../../../../../../shared/utils/index';

export class GasStationCorrectionController extends DataCorrectionController {

	protected getFeedbackType(): FeedbackType {
		return FeedbackType.GASSTATION;
	}

	public submitListener(event: JQuery.Event): void {
		event.preventDefault();

		this.appViewService.hideMessages();
		if (this.appValidationService && this.appValidationService.isValid()) {
			AppUtils.View.startLoader();

			const formModel = this.appPersistenceService.getFormModelFromStore();
			// if you modify model data here, don't forget to write it back to store
			//this.appPersistenceService.setFormModelToStore(formModel);

			this.appApiService.submitGasStationCorrection(
				formModel,
				this.appViewService.getVerificationToken(),
				this.handleSubmitSuccessCallback.bind(this),
				this.handleDefaultErrorCallback.bind(this)
			);
		}
	}

	private handleSubmitSuccessCallback(data: CorrectionResponseApi): void {
		if (data.success) {
			this.renderSuccessTemplate(data);
		} else {
			this.appViewService.showGeneralError(data.message);
		}
		AppUtils.View.stopLoader();
	}

	private handleDefaultErrorCallback(jqxhr: JQueryXHR): void {
		this.appErrorService.handleDefaultErrorResponse(
			jqxhr,
			this.options.name,
			() => this.showAndTriggerValidationError(jqxhr),
			() => this.appPersistenceService.clearApplicationSession()
		);
	}

	private showAndTriggerValidationError(jqxhr: JQueryXHR): void {
		if (this.appValidationService) {
			this.appValidationService.showServerValidationErrors(jqxhr);
			this.appValidationService.triggerValidation();
		}
	}
}